<div fxLayout="column" fxLayoutGap="10px" >
  <fab-loading-spinner *ngIf="isLoading"></fab-loading-spinner>
  <div dynamicGrid [tableContainerElement]="tableContainer" [selector]="selector" #tableContainer class="table-height table-flex">
    <table mat-table [dataSource]="dataSource" matSort matSortActive="fecProceso" matSortDirection="desc" matSortDisableClear (matSortChange)="onSortChange()" #dataTable>

      <!-- File Name Column -->
      <ng-container matColumnDef="nombreDeArchivo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre de Archivo
          <rem-string-filter #tableFilter columnDef="nombreDeArchivo" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-med-decription">
           <span>
                {{element.nombreDeArchivo}}
           </span>
        </td>
      </ng-container>

      <!-- Message Column -->
      <ng-container matColumnDef="message">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Message
          <rem-string-filter #tableFilter columnDef="message" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="cell-width-description" *matCellDef="let element">
          {{element.message}}
        </td>
      </ng-container>

      <!-- Fec Proceso Column -->
      <ng-container matColumnDef="fecProceso">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Proceso
          <rem-date-filter #tableFilter columnDef="fecProceso" [operators]="dateOperators" (filterChange)="filterChange($event);"></rem-date-filter>
        </th>
        <td mat-cell  class="cell-width-smtext" *matCellDef="let element"> {{element.fecProceso | customDate}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator
    [pageSize]="pageSizes[0]"
    [pageSizeOptions]="pageSizes"
    [length]="totalElements"
    (page)="updatePageState()">
  </mat-paginator>
</div>

